import {
  EAutoBrazeCTA,
  EProfileBrazeCTA,
  ERentersBrazeCTA,
} from '@@/auto/interfaces';
import { TAccountModals } from '@@/common/constants/accountModals';

export type TBrazeCTAConfig = {
  auto: Record<EAutoBrazeCTA, TAccountModals | null>;
  profile: Record<EProfileBrazeCTA, TAccountModals>;
  renters: Record<ERentersBrazeCTA, TAccountModals | null>;
};

export const brazeCTAConfig: TBrazeCTAConfig = {
  auto: {
    BEGIN_AUTO_POLICY_EDITS: 'CONFIRM_POLICY_EDITS',
    CANCEL_AUTO_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    DIGITAL_ID: 'DIGITAL_ID',
    UPDATE_AUTO_PAYMENT_METHOD: null,
  },
  profile: {
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    UPDATE_CONTACT_INFO: 'UPDATE_CONTACT_INFO',
  },
  renters: {
    BREAK_UP: 'BREAK_UP',
    CANCEL_RENTERS_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    // Support for older braze card configuration (will be removed with [sc-153484])
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    INTERESTED_PARTY: 'INTERESTED_PARTY',
    UPDATE_ADDRESS: 'UPDATE_ADDRESS',
    UPDATE_RENTERS_PAYMENT_METHOD: null,
  },
};

export const editPolicyRentersBrazeCTAList = [
  'INTERESTED_PARTY',
  'UPDATE_ADDRESS',
];
